<template>
    <!-- 面包屑导航（语义化） -->
    <div class="h-[60px] leading-[60px]" style="background-color: rgb(245, 245, 245);">
        <div class="container mx-auto">
            <nav aria-label="Breadcrumb" class="breadcrumb-container text-sm leading-[60px] px-4">
                <ol class="flex items-center list-none m-0 p-0">
                    <template v-for="(item, index) in breadcrumbList" :key="index">
                        <li v-if="index === breadcrumbList.length - 1"
                            class="breadcrumb-item breadcrumb-item-last text-gray-700 font-medium"
                            aria-current="page">
                            <span v-if="index === 0" class="icon-home mr-1" aria-hidden="true"></span>
                            <span class="breadcrumb-text">{{ item.name }}</span>
                        </li>
                        <li v-else class="breadcrumb-item text-gray-500 hover:text-green-600">
                            <nuxt-link :to="item.url">
                                <span v-if="index === 0" class="icon-home mr-1" aria-hidden="true"></span>
                                <span class="breadcrumb-text">{{ item.name }}</span>
                            </nuxt-link>
                            <span class="breadcrumb-separator mx-2 text-gray-500 flex-shrink-0" aria-hidden="true">&gt;</span>
                        </li>
                    </template>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script setup lang="ts">

    const route = useRoute()
    const getBreadcrebList = () => {
        let breadcrumbList = []
        const pathList = route.path.split('/')
        for (let i = 0; i < pathList.length; i++) {
            let breadcrumb: any = {}
            if (i == 0) {
                breadcrumb.name = 'Home';
                breadcrumb.url = '/'
                breadcrumbList.push(breadcrumb)
                continue
            } else if (i == pathList.length - 1) {
                breadcrumb.name = pathList[i]!.replaceAll('-', ' ').replace('.html', '')
                breadcrumb.url = null
                breadcrumbList.push(breadcrumb)
                continue
            } else {
                breadcrumb.name = pathList[i]!.replaceAll('-', ' ')
                if (i - 1 == 0) {
                    breadcrumb.url = "/" + pathList[i]
                } else {
                    breadcrumb.url = breadcrumbList[i - 1].url.replace('.html', '') + '/' + pathList[i] 
                }

                breadcrumbList.push(breadcrumb)
            }
        }
        return breadcrumbList
    }

    const breadcrumbList = ref<any[]>([])
    breadcrumbList.value = getBreadcrebList()

</script>
<style lang="scss" scoped>
    .breadcrumb-container{
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

</style>